import admin from './admin'

const install = function (Vue) {
  // 用法：v-admin 仅管理员可见（role === 'admin'）
  Vue.directive('admin', admin)
}

export default {
  install
}

